// VoltaGrid bid summary — the Power Block 4 price table from the estimate
// export (Section 1–8 labor / material / subcontract / total, then fee at
// risk, total incl. fee, the owner-recommended 5% contingency and the grand
// total), in the Budget Overview grid's own styling. Static figures for now: the numbers
// are the 9/15/26 bid as priced, not read off the Day Zero budget yet.
import React from 'react';

// The job this price table is the bid for. Every other VoltaGrid job (the
// 54026070 QPAC Blitz) prices its sections off its own Day Zero budget.
export const BID_JOB = '54026071';

export const BID_SECTIONS = [
    { sec: 1, name: 'Indirects', labor: 15434291, material: 14344, sub: 875460 },
    { sec: 2, name: 'Piping', labor: 1348295, material: 2814098, sub: 1265865 },
    { sec: 3, name: 'Coating', labor: 170704, material: 1232, sub: 234350 },
    { sec: 4, name: 'Equipment', labor: 11237141, material: 0, sub: 932960 },
    { sec: 5, name: 'Electrical', labor: 8589295, material: 14803319, sub: 500000 },
    { sec: 6, name: 'Instrumentation', labor: 108106, material: 71202, sub: 0 },
    { sec: 7, name: 'Structural Steel', labor: 148945, material: 724094, sub: 0 },
    { sec: 8, name: 'Commissioning', labor: 104108, material: 0, sub: 200000 },
];
export const FEE_AT_RISK = 1500000;
export const CONTINGENCY_PCT = 0.05;
// The workbook's own feet. The section rows above are rounded to the
// dollar, so summing them lands a dollar or two under these; the table
// shows the workbook's totals, not a re-add of the rounded rows.
export const BID_TOTALS = { labor: 37140886, material: 18428290, sub: 4008635, total: 59577811, inclFee: 61077811, contingency: 2978891, grand: 64056702 };

const money = (n) => Math.round(n).toLocaleString('en-US');

function VoltaGridBidSummary({ palette }) {
    const totals = BID_TOTALS;
    const { total, inclFee, contingency, grand } = BID_TOTALS;

    // Styled like the Budget Overview grid, not the workbook: same header,
    // cell and summary-band treatment the Fusion tables use.
    const th = { padding: '5px 6px', textAlign: 'right', fontSize: 8, fontWeight: 700, color: palette.blue700, textTransform: 'uppercase', letterSpacing: '.04em', borderBottom: `2px solid ${palette.blue200}`, background: palette.blue50, whiteSpace: 'nowrap' };
    const thL = { ...th, textAlign: 'left' };
    const td = { padding: '4px 6px', fontSize: 10, borderBottom: `1px solid ${palette.border}`, whiteSpace: 'nowrap', textAlign: 'right', color: palette.text, fontVariantNumeric: 'tabular-nums' };
    const tdL = { ...td, textAlign: 'left' };
    const tdC = { ...td, textAlign: 'center', color: palette.muted };
    const bandTotal = { ...td, fontWeight: 800, background: palette.blue200, color: palette.blue900 };
    const bandLight = { ...td, fontWeight: 700, background: palette.blue100 };

    return (
        <div style={{ overflowX: 'auto' }}>
            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                    <tr>
                        <th style={{ ...th, textAlign: 'center', width: 36 }}>Sec</th>
                        <th style={thL}>Description</th>
                        <th style={th}>Labor</th>
                        <th style={th}>Material</th>
                        <th style={th}>Subcontract</th>
                        <th style={th}>Total Price</th>
                    </tr>
                </thead>
                <tbody>
                    {BID_SECTIONS.map((r) => (
                        <tr key={r.sec}>
                            <td style={tdC}>{r.sec}</td>
                            <td style={tdL}>Section {r.sec} — {r.name}</td>
                            <td style={td}>{money(r.labor)}</td>
                            <td style={td}>{money(r.material)}</td>
                            <td style={td}>{money(r.sub)}</td>
                            <td style={td}>{money(r.labor + r.material + r.sub)}</td>
                        </tr>
                    ))}
                    <tr>
                        <td style={bandTotal} />
                        <td style={{ ...bandTotal, textAlign: 'left' }}>Power Block 4 — Total</td>
                        <td style={bandTotal}>{money(totals.labor)}</td>
                        <td style={bandTotal}>{money(totals.material)}</td>
                        <td style={bandTotal}>{money(totals.sub)}</td>
                        <td style={bandTotal}>{money(total)}</td>
                    </tr>
                    <tr>
                        <td style={td} />
                        <td style={{ ...tdL, fontWeight: 700 }}>Fee at Risk</td>
                        <td style={td} /><td style={td} /><td style={td} />
                        <td style={{ ...td, fontWeight: 700 }}>{money(FEE_AT_RISK)}</td>
                    </tr>
                    <tr>
                        <td style={bandLight} />
                        <td style={{ ...bandLight, textAlign: 'left' }}>Total incl. Fee</td>
                        <td style={bandLight} /><td style={bandLight} /><td style={bandLight} />
                        <td style={bandLight}>{money(inclFee)}</td>
                    </tr>
                    <tr>
                        <td style={td} />
                        <td style={tdL} colSpan={4}>Recommended Contingency (Owner-recommended) — {Math.round(CONTINGENCY_PCT * 100)}%</td>
                        <td style={td}>{money(contingency)}</td>
                    </tr>
                    <tr>
                        <td style={bandLight} />
                        <td style={{ ...bandLight, textAlign: 'left' }}>Total incl. Owner-Recommended Contingency</td>
                        <td style={bandLight} /><td style={bandLight} /><td style={bandLight} />
                        <td style={bandLight}>{money(grand)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default VoltaGridBidSummary;
